import { useMemo } from 'react'

import { MedicalReviewApi } from 'interfaces/types'

export function useHomeTrustful(props: {
  medicalReviewed: MedicalReviewApi[]
}) {
  const { medicalReviewed } = props

  const trustfulItems = useMemo(() => {
    return (
      medicalReviewed?.[0]?.items?.map((item) => {
        return {
          title: item.title,
          description: item.description,
          icon: item.image_url,
        }
      }) || []
    )
  }, [medicalReviewed])

  return useMemo(() => ({ trustfulItems }), [trustfulItems])
}
